/**
 * Recently viewed products — Mar Amoli
 *
 * Tracks last N products viewed in localStorage. Used to revive intent
 * cuando el usuario regresa al carrito o vuelve a la home — muestra "Te
 * interesaba esto" sin que Mariana tenga que curar nada.
 *
 * Storage key: 'ma-recently-viewed'
 * Storage shape: [{ id, handle, title, image, price, url, ts }, ...]
 *   - Sorted most-recent first
 *   - Max 6 items
 *   - 30-day TTL per item (auto-purged on read)
 *
 * Public API: window.MaRecentlyViewed
 *   .track(product)   — push a product onto the stack (call from PDPs)
 *   .list()           — return current array (cleaned)
 *   .clear()          — wipe the list
 *   .render(targetEl, opts) — render cards into a container
 *     opts.limit (default 3)
 *     opts.excludeHandles (array of handles to skip — useful para no mostrar
 *                          el producto que estás viendo)
 *     opts.style ('compact' | 'card') — layout flavor
 *
 * Seguridad: render usa createElement+textContent (no innerHTML).
 */
(function () {
  "use strict";

  var KEY = "ma-recently-viewed";
  var MAX = 6;
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  function readRaw() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      if (!Array.isArray(arr)) return [];
      return arr;
    } catch (e) {
      return [];
    }
  }

  function writeRaw(arr) {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch (e) {
      // Quota exceeded — silent
    }
  }

  function cleanList(arr) {
    var now = Date.now();
    var seen = {};
    return arr
      .filter(function (it) {
        if (!it || !it.handle) return false;
        if (it.ts && now - it.ts > TTL_MS) return false;
        if (seen[it.handle]) return false;
        seen[it.handle] = true;
        return true;
      })
      .slice(0, MAX);
  }

  function track(product) {
    if (!product || !product.handle) return;
    var arr = readRaw();
    // Remove any existing entry for this handle (we'll re-add at the top)
    arr = arr.filter(function (it) {
      return it && it.handle !== product.handle;
    });
    arr.unshift({
      id: product.id || null,
      handle: product.handle,
      title: product.title || "",
      image: product.image || "",
      price: typeof product.price === "number" ? product.price : null,
      url: product.url || "/products/" + product.handle,
      ts: Date.now(),
    });
    arr = cleanList(arr);
    writeRaw(arr);
  }

  function list() {
    var arr = readRaw();
    var cleaned = cleanList(arr);
    // Re-write if we cleaned anything
    if (cleaned.length !== arr.length) writeRaw(cleaned);
    return cleaned;
  }

  function clear() {
    try {
      localStorage.removeItem(KEY);
    } catch (e) {}
  }

  function formatMoney(cents) {
    var n = (cents || 0) / 100;
    try {
      return n.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
        maximumFractionDigits: n % 1 === 0 ? 0 : 2,
      });
    } catch (e) {
      return "$" + n.toFixed(0) + " MXN";
    }
  }

  function buildSizedImage(src, w) {
    if (!src) return null;
    try {
      var u = new URL(src, window.location.origin);
      u.searchParams.set("width", String(w));
      return u.toString();
    } catch (e) {
      return src;
    }
  }

  function renderCardCompact(item) {
    var card = document.createElement("a");
    card.className = "ma-recently__card ma-recently__card--compact";
    card.href = item.url;
    card.setAttribute("aria-label", item.title);

    if (item.image) {
      var img = document.createElement("img");
      img.src = buildSizedImage(item.image, 160);
      img.alt = item.title || "";
      img.width = 56;
      img.height = 56;
      img.loading = "lazy";
      img.className = "ma-recently__img";
      card.appendChild(img);
    }

    var body = document.createElement("div");
    body.className = "ma-recently__body";
    var title = document.createElement("div");
    title.className = "ma-recently__title";
    title.textContent = item.title || "";
    body.appendChild(title);

    // Estrellas entre el nombre y el precio, igual que en el carrito. El hueco
    // se marca siempre: si el mapa de calificaciones aún no llegó, lo rellena
    // fillPendingRatings() de component-cart-recommendations.js al resolverse.
    var rating = document.createElement("div");
    rating.className = "ma-recently__rating";
    rating.setAttribute("data-ma-rating-for", item.handle);
    body.appendChild(rating);
    if (window.MaRatings && window.MaRatings.attach) {
      window.MaRatings.attach(rating, item.handle);
    }

    if (item.price != null) {
      var price = document.createElement("div");
      price.className = "ma-recently__price";
      price.textContent = formatMoney(item.price);
      body.appendChild(price);
    }
    card.appendChild(body);

    return card;
  }

  function render(targetEl, opts) {
    if (!targetEl) return;
    opts = opts || {};
    var limit = opts.limit || 3;
    var exclude = opts.excludeHandles || [];
    var style = opts.style || "compact";

    var items = list().filter(function (it) {
      return exclude.indexOf(it.handle) === -1;
    });

    while (targetEl.firstChild) targetEl.removeChild(targetEl.firstChild);

    if (items.length === 0) {
      targetEl.setAttribute("hidden", "");
      return;
    }

    targetEl.removeAttribute("hidden");
    var slice = items.slice(0, limit);
    slice.forEach(function (it) {
      var card = style === "compact" ? renderCardCompact(it) : renderCardCompact(it);
      targetEl.appendChild(card);
    });
  }

  window.MaRecentlyViewed = {
    track: track,
    list: list,
    clear: clear,
    render: render,
  };

  // Auto-track from PDP — busca un nodo con data-ma-pdp-track con info del producto
  document.addEventListener("DOMContentLoaded", function () {
    var trackerEl = document.querySelector("[data-ma-pdp-track]");
    if (!trackerEl) return;
    try {
      var data = JSON.parse(trackerEl.getAttribute("data-ma-pdp-track"));
      if (data && data.handle) track(data);
    } catch (e) {
      // bad JSON — silent
    }
  });

  // Auto-render en cualquier contenedor con data-ma-recently-viewed
  // Pasa opts via atributos: data-limit, data-exclude (csv), data-style
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-ma-recently-viewed]").forEach(function (el) {
      var limit = parseInt(el.getAttribute("data-limit") || "3", 10);
      var excludeRaw = el.getAttribute("data-exclude") || "";
      var exclude = excludeRaw
        ? excludeRaw.split(",").map(function (s) {
            return s.trim();
          })
        : [];
      var style = el.getAttribute("data-style") || "compact";
      render(el, { limit: limit, excludeHandles: exclude, style: style });
    });
  });
})();
